module.exports = __webpack_public_path__ + "img/userOrders.80d8f18b.svg";